
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The email address that candidate applications are directed to.`}</p>
    <p>{`Do not select this in your operations,
or your integration will break when the field is removed.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;